export enum SystemTaskType {
  AccountingCalendarValidation = "ACCOUNTING_CALENDAR_VALIDATION",
  ComplianceCalendarValidation = "COMPLIANCE_CALENDAR_VALIDATION",
  HolidayCalendarValidation = "HOLIDAY_CALENDAR_VALIDATION",
  InvoicingCalendarValidation = "INVOICING_CALENDAR_VALIDATION",
  PayableCalendarValidation = "PAYABLE_CALENDAR_VALIDATION",
  PayrollCalendarValidation = "PAYROLL_CALENDAR_VALIDATION",
  TimesheetCalendarValidation = "TIMESHEET_CALENDAR_VALIDATION",
  FylaAndFycpValidation = "FYLA_AND_FYCP_VALIDATION",
  TimesheetValidation = "TIMESHEET_VALIDATION",
  CustomerInvoiceValidation = "CUSTOMER_INVOICE_VALIDATION",
  ExpenseReportValidation = "EXPENSE_REPORT_VALIDATION",
  VendorInvoiceValidation = "VENDOR_INVOICE_VALIDATION",
  JournalEntryValidation = "JOURNAL_ENTRY_VALIDATION",
  ProvisionalRateValidation = "FYCP_AND_PROVISIONALRATE_VALIDATION"
}
